<template>
  <component :is="view"></component>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'view-default',
  computed: {
    ...mapState('account', ['user']),
    ...mapGetters('permission', ['hasPermission']),
    view() {
      return this.hasPermission('customer.get') ? 'view-auth' : 'view-admin'
    }
  }
}
</script>